export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/569373b84d4fa61cda98164451d2ed57.svg";